import { PartnerType, Permission } from '../../../legacy/common/types'
import { type AccessControlConfig } from '../../components/AccessControl/accessControl.utils'

export const CatalogSectionAccessControl: AccessControlConfig = {
  permissions: Permission.PackagesDashboardCatalogProductsView,
  partnerTypes: PartnerType.Retailer,
}
